import { axiosInstance } from "./AxiosDefaults";
import {
  documentsRoute,
  requestsRoute,
  dispositionsByRequestRoute,
  registrationNumbersRoute,
  driverNamesRoute,
  dispositionsRoute,
  oneDocumentRoute,
  dispositionsByDateProductInputRoute,
  dispositionsByDateRoute,
  requestsByDateRoute,
  ownershipDocumentsRoute,
  servicedMeasurementsRoute,
  productReservationsRoute,
  stockBalanceSyncRoute,
  stockBalanceMercantileAvailableRoute,
  stockBalanceReproAvailableSalesRoute,
  stockBalanceOnHandRoute,
  prevRequestsRoute,
  auditLogRoute,
  oneDocumentVirtualWarehouseRoute,
} from "../constants/ApiRoutes";
import { Disposition } from "../models/Disposition";
import { Request } from "../models/Request";
import { DocumentOfReceive } from "../models/DocumentOfReceive";
import { ServicedMeasurement } from "../models/ServicedMeasurement";

export const getAllDocuments = (
  isMercantile: boolean,
  isInput: boolean,
  dateFrom?: Date,
  dateTo?: Date,
  isWarehouseman?: boolean,
  warehouseId?: string,
): Promise<any> => {
  let formatedRoute = `${documentsRoute}/new-version`;
  formatedRoute +=
    isMercantile === true ? "?mercantile=true" : "?mercantile=false";
  formatedRoute += isInput === true ? "&input=true" : "&input=false";
  if (dateFrom && dateTo) {
    formatedRoute += `&datefrom=${dateFrom.toDateString()}&dateto=${dateTo.toDateString()}`;
  }
  if (isWarehouseman !== undefined) {
    formatedRoute += `&isWarehouseman=${isWarehouseman}`;
  }
  if (warehouseId) {
    formatedRoute += `&warehouseId=${warehouseId}`;
  }
  return axiosInstance.get(formatedRoute, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

export const getOneDocument = (id: string): Promise<any> => {
  return axiosInstance.get(`${oneDocumentRoute}/${id}`, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

export const getDocumentVirtualWarehouse = (): Promise<any> => {
  return axiosInstance.get(`${oneDocumentVirtualWarehouseRoute}`, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

export const getAllRequests = (
  isMercantile: boolean,
  dateFrom?: Date,
  dateTo?: Date,
): Promise<any> => {
  let formatedRoute = `${requestsRoute}/new-version`;
  formatedRoute +=
    isMercantile === true ? "?mercantile=true" : "?mercantile=false";
  if (dateFrom && dateTo) {
    formatedRoute += `&datefrom=${dateFrom.toDateString()}&dateto=${dateTo.toDateString()}`;
  }
  return axiosInstance.get(formatedRoute, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

export const getOneRequest = (id: string): Promise<any> => {
  return axiosInstance.get(`${prevRequestsRoute}/${id}`, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

export const addNewRequest = (payload: Partial<Request>): Promise<any> => {
  return axiosInstance.post(`${prevRequestsRoute}`, payload, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

export const updateOneRequest = (id: string, request: any): Promise<any> => {
  return axiosInstance.put(`${prevRequestsRoute}/${id}`, request, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

export const deleteOneRequest = (id: string): Promise<any> => {
  return axiosInstance.delete(`${prevRequestsRoute}/${id}`, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

export const updateRequestBackofficeStatus = (
  requestId: string,
  backofficeApproved: boolean,
): Promise<any> => {
  return axiosInstance.patch(
    `${requestsRoute}/${requestId}/backoffice-approval`,
    { backofficeApproved },
    {
      withCredentials: false,
      headers: { "Content-Type": "application/json" },
    },
  );
};

export const getDispositionsByRequest = (id: string): Promise<any> => {
  return axiosInstance.get(`${dispositionsByRequestRoute}/${id}`, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

export const getOneDisposition = (id: string): Promise<any> => {
  return axiosInstance.get(`${dispositionsRoute}/${id}`, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

export const addNewDisposition = (disposition: Disposition): Promise<any> => {
  return axiosInstance.post(`${dispositionsRoute}`, disposition, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

export const updateOneDisposition = (
  id: string,
  disposition: Disposition,
): Promise<any> => {
  return axiosInstance.put(`${dispositionsRoute}/${id}`, disposition, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

export const deleteOneDisposition = (id: string): Promise<any> => {
  return axiosInstance.delete(`${dispositionsRoute}/${id}`, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

export const getAllRegistrationNumbers = (): Promise<any> => {
  return axiosInstance.get(registrationNumbersRoute, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

export const getAllDriverNames = (): Promise<any> => {
  return axiosInstance.get(driverNamesRoute, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

export const addNewDocument = (document: DocumentOfReceive): Promise<any> => {
  return axiosInstance.post(`${oneDocumentRoute}`, document, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

export const updateOneDocument = (
  id: string,
  document: Partial<DocumentOfReceive>,
): Promise<any> => {
  return axiosInstance.put(`${oneDocumentRoute}/${id}`, document, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

export const deleteOneDocument = (id: string): Promise<any> => {
  return axiosInstance.delete(`${oneDocumentRoute}/${id}`, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

export const getAllDispositionsByDate = (
  //disposition map page
  dateFrom: Date,
): Promise<any> => {
  const formatedRoute = `${dispositionsByDateRoute}/date?datefrom=${dateFrom.toDateString()}`;
  return axiosInstance.get(formatedRoute, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

export const getAllDispositionsProductInputByDate = (
  //disposition map page
  dateFrom: Date,
): Promise<any> => {
  const formatedRoute = `${dispositionsByDateProductInputRoute}/date?datefrom=${dateFrom.toDateString()}`;
  return axiosInstance.get(formatedRoute, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

export const getAllRequestsByDate = (
  //dispositions by request page
  dateFrom: Date,
): Promise<any> => {
  const formatedRoute = `${requestsByDateRoute}/date?datefrom=${dateFrom.toDateString()}`;
  return axiosInstance.get(formatedRoute, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

//izvestaj tudja roba na lageru
export const getAllForeignProductDocuments = (
  mercantile: boolean = true,
): Promise<any> => {
  return axiosInstance.get(
    `${oneDocumentRoute}/foreign-products/foreign-products?mercantile=${mercantile}`,
    {
      withCredentials: false,
      headers: { "Content-Type": "application/json" },
    },
  );
};

export const getAllOwnershipDocuments = (): Promise<any> => {
  return axiosInstance.get(ownershipDocumentsRoute, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

export const getAllServicedMeasurements = (): Promise<any> => {
  return axiosInstance.get(servicedMeasurementsRoute, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

export const getOneServicedMeasurement = (id: string): Promise<any> => {
  return axiosInstance.get(`${servicedMeasurementsRoute}/${id}`, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

export const addNewServicedMeasurement = (
  servicedMeasurement: ServicedMeasurement,
): Promise<any> => {
  return axiosInstance.post(
    `${servicedMeasurementsRoute}`,
    servicedMeasurement,
    {
      withCredentials: false,
      headers: { "Content-Type": "application/json" },
    },
  );
};

export const updateOneServicedMeasurement = (
  id: string,
  servicedMeasurement: ServicedMeasurement,
): Promise<any> => {
  return axiosInstance.put(
    `${servicedMeasurementsRoute}/${id}`,
    servicedMeasurement,
    {
      withCredentials: false,
      headers: { "Content-Type": "application/json" },
    },
  );
};

export const getProductReservations = (
  year?: number,
  dateFrom?: Date,
  dateTo?: Date,
): Promise<any> => {
  let formatedRoute = productReservationsRoute;
  const params: string[] = [];

  // poslovna godina (opciono)
  if (typeof year === "number") {
    params.push(`year=${year}`);
  }

  // eksplicitan opseg datuma (opciono)
  if (dateFrom && dateTo) {
    // koristiš isti format kao i ostali API-ji: datefrom / dateto
    params.push(`datefrom=${dateFrom.toDateString()}`);
    params.push(`dateto=${dateTo.toDateString()}`);
  }

  if (params.length > 0) {
    formatedRoute += "?" + params.join("&");
  }

  return axiosInstance.get(formatedRoute, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

// ---------------------------
// STOCK BALANCE API
// ---------------------------

export const syncStockBalanceYear = (year: number): Promise<any> => {
  return axiosInstance.post(`${stockBalanceSyncRoute}/${year}`, null, {
    withCredentials: false,
  });
};

// Merkantila: dostupno stanje za poručivanje (forma zahteva prodaje merkantile)
export const getMercantileAvailableSales = (params: {
  year: number;
  warehouseId: string;
  productId: string;
}): Promise<any> => {
  const route =
    `${stockBalanceMercantileAvailableRoute}` +
    `?year=${params.year}&warehouseId=${params.warehouseId}&productId=${params.productId}`;

  return axiosInstance.get(route, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

// Repromaterijal: dostupno stanje za poručivanje (forma zahteva prodaje repro)
// vraća dva broja: sa i bez virtual
export const getReproAvailableSales = (params: {
  year: number;
  productId: string;
}): Promise<any> => {
  const route =
    `${stockBalanceReproAvailableSalesRoute}` +
    `?year=${params.year}&productId=${params.productId}`;

  return axiosInstance.get(route, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

// On-hand: stanje po magacinu i robi (npr. direktna otpremnica repro)
export const getOnHand = (params: {
  year: number;
  warehouseId: string;
  productId: string;
}): Promise<any> => {
  const route =
    `${stockBalanceOnHandRoute}` +
    `?year=${params.year}&warehouseId=${params.warehouseId}&productId=${params.productId}`;

  return axiosInstance.get(route, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

export const getAuditLogs = (dateFrom?: Date, dateTo?: Date): Promise<any> => {
  let formatedRoute = `${auditLogRoute}`;

  const params: string[] = [];

  if (dateFrom) params.push(`datefrom=${dateFrom.toDateString()}`);
  if (dateTo) params.push(`dateto=${dateTo.toDateString()}`);

  if (params.length > 0) {
    formatedRoute += `?${params.join("&")}`;
  }

  return axiosInstance.get(formatedRoute, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};
